import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { GS1LoadingService, GS1NotificationService } from "@gs1france/gs1-components-library";
import { OAuthService } from "angular-oauth2-oidc";

@Component({
  selector: 'disconnect-dialog',
  templateUrl: './disconnected-dialog.component.html'
})
export class DisconnectedDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DisconnectedDialogComponent>,
    private _auth: OAuthService,
    private _loading: GS1LoadingService,
    private _notif: GS1NotificationService
    ) {}

    reconnect() {
      this._loading.startLoading('reconnect');
      try {
        
        this._auth.resetImplicitFlow();
        this._auth.customQueryParams={};
        this._auth.initImplicitFlow();
      } catch {
        this._loading.stopLoading('reconnect');
        this._notif.addNotification('Nous n\'avons pas réussi à vous reconnecter, Merci de réessayer ultérieurement.', 'error');
      }
    }
}
